import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const ScheduleViewMode = ({ name, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "选择模式" })}
      clearable={false}
      options={[
        { id: 1, name: t({ defaultMessage: "设备排程" }) },
        { id: 2, name: t({ defaultMessage: "排程执行情况" }) }
      ]}
      name={name}
      value={value}
      onChange={onChange}
      style={{ width: 150 }}
    />
  );
};

export default ScheduleViewMode;
